import { useEffect } from "react";

import { useWindowSize } from "@newsela/angelou";
import {
  useTracker as useTrackerSnitch,
  eventTypes,
  actionNames,
} from "@newsela/snitch";
import { useRouter } from "next/router";

const useTrackPageView = () => {
  const router = useRouter();
  const { trackAction, getEventName } = useTrackerSnitch();

  const windowSize = useWindowSize();
  // For home page view event, track screen size
  const extraProperties = { screen_size: null };
  if (router.pathname === "/home") {
    extraProperties.screen_size = windowSize;
  }

  useEffect(() => {
    trackAction({
      event_type: eventTypes.pageView,
      event_name: getEventName(null, null, actionNames.pageView),
      dimension_properties: {
        description: "Page view.",
      },
      ...extraProperties,
    });
  }, [router.pathname]);
};

export default useTrackPageView;
